import { type ReactNode } from 'react'
import { usePage } from '@inertiajs/react'
import { AuthLayout } from '@/components/ui'
import { Logo } from '@/components/brand/Logo'
import { FlashToaster } from '@/components/common/FlashToaster'
import type { SharedProps } from '@/types'

/**
 * Branded wrapper for the auth screens (sign-in, password reset). Centers a
 * card with the Collectia logo + heading on the Catalyst AuthLayout.
 */
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: string
  children: ReactNode
}) {
  const { props } = usePage<SharedProps>()

  return (
    <AuthLayout>
      <FlashToaster />
      <div className="w-full max-w-sm">
        <Logo variant="blue" src={props.branding.logo_blue} className="h-9" alt={props.branding.brand_name} />
        <h1 className="mt-8 font-heading text-h2 font-bold text-text-strong">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-text">{subtitle}</p>}
        <div className="mt-8">{children}</div>
      </div>
    </AuthLayout>
  )
}

/** Inline error banner for form-level (non-field) errors. */
export function FormError({ message }: { message?: string }) {
  if (!message) return null
  return (
    <div
      role="alert"
      className="mb-4 rounded-control bg-status-failed-bg px-3 py-2 text-sm text-status-failed-fg"
    >
      {message}
    </div>
  )
}
